import { gql } from "@apollo/client";
import { graph } from "config/axios-context";
import { DeleteSaleDocument, DeleteSaleMutation, DeleteSaleMutationVariables, SaleFilterInput } from "types/graphql";

export const fruitCategoriesIdNameQuery = gql`
query fruitCategoriesIdName($where: FruitCategoryFilterInput, $order: [FruitCategorySortInput!], $take: Int, $skip: Int) {
  fruitCategories {
    items(where: $where, take: $take, skip:$skip, order: $order) {
      name,
      id
    }
  }
}
`;

export const fruitGroupsIdNameQuery = gql`
query fruitGroupsIdName($where: FruitGroupFilterInput, $order: [FruitGroupSortInput!], $take: Int, $skip: Int) {
  fruitGroups {
    items(where: $where, take: $take, skip:$skip, order: $order) {
      name,
      id
    }
  }
}
`

export const fruitsIdNameQuery = gql`
query fruitsIdName($where: FruitFilterInput $order: [FruitSortInput!], $take: Int, $skip: Int) {
  fruits {
    items(where: $where, take: $take, skip:$skip, order: $order) {
      name,
      id
    }
  }
}
`

export const saveSaleMutation = gql`
mutation saveSale($sale: SaleInput!) {
  sale(model: $sale) {
       id,
       name
  }
}
`

export const deleteSaleMutation = gql`
mutation DeleteSale($id: Int, $where: SaleFilterInput) {
  saleDelete(id:$id, where:$where) 
}
`

export const saleTemplateMutation = gql`
mutation SaleTemplate($saleTemplate: SaleTemplateInput!) {
  saleTemplate(model: $saleTemplate) {
       id,
       name
  }
}
`

export const saleDatalistQuery = gql`
query saleDatalist($where: SaleFilterInput, $order: [SaleSortInput!], $take: Int, $skip: Int) {
  sales {
    items(order: $order, skip: $skip, take:$take, where: $where) {
      id,
      type,
      person {
        id,
        name
      },
      wallet {
        id,
        name,
        balance,
        archived
      }
      fruit {
        id, name
      },
      season {
        id,
        name
      }
      kg,
      pricePerKg,
      total,
      date,
      category {
        name
        id
      },
      cartQuantity,
      chamber
    },
    count(where: $where)
  }
}
`;

export const saleDatalistAndTotalQuery = gql`
query saleDatalistAndTotal($where: SaleFilterInput, $order: [SaleSortInput!], $take: Int, $skip: Int) {
  sales {
    items(order: $order, skip: $skip, take:$take, where: $where) {
      id,
      type,
      person {
        id,
        name
      }
      wallet {
        id,
        name,
        balance
        archived
      }
      fruit {
        id, name
      },
      season {
        id,
        name
      }
      kg,
      pricePerKg,
      total,
      date,
      category {
        name
        id
      },
      cartQuantity,
      chamber
    },
    totalSum(order: $order, where: $where)
    kgSum(order: $order, where: $where)
    pricePerKgAverage(order: $order, where: $where)
    cartQuantitySum(order: $order, where: $where)
    count(where: $where)
  }
}
`;

// #region delete
export const deleteSaleTemplate = gql`
mutation DeleteSaleTemplate($id: Int, $where: SaleTemplateFilterInput) {
  saleTemplateDelete(id: $id, where: $where)
}
`;

export const saleMultiupdate = gql`
mutation SaleMultiUpdate($data: [SaleMultiUpdateInput!]!) {
  saleMultiUpdate(sales: $data)
}
`;


export async function deleteSale(condition: number | SaleFilterInput) {
  try {
    const response = await graph<DeleteSaleMutation, DeleteSaleMutationVariables>({
      query: DeleteSaleDocument,
      variables: {
        id: typeof condition == 'number' ? condition : undefined,
        where: typeof condition != 'number' ? condition : undefined
      }
    });
  
    if(response.errors?.length) {
      throw response.errors;
    }

    return response.data?.saleDelete;
  } catch (error) {
    throw error;
  }
}
// #endregion delete
